<template>
  <section>
    <transition name="fade">
      <section style="position: absolute; width: 100%;">
        <v-container v-if="preloader">
          <div class="text-center">
            <v-progress-circular indeterminate></v-progress-circular>
          </div>
        </v-container>
      </section>
    </transition>

    <div :class="showContent" class="row custom-appointments">
      <div class="col-12 mt-0 pt-0">
        <EditedUser
          :userID="userID"
          :typeSkill="typeSkill"
          secondBtn="true"
          :emptyUser="getEmpty()"
          :users="users"
          @getSkillType="getSkillTypeCurrent"
          @getCurrentUser="getCurrentUserData"
          @addInterview="addInterview"
        />

        <div v-if="!getEmpty()" class="apply-template-bar">
          <select v-model="selectedTemplateId" class="apply-template-select">
            <option :value="null">Применить шаблон...</option>
            <option v-for="tpl in templates" :key="tpl.id" :value="tpl.id">
              {{ tpl.title }}{{ tpl.shared && !tpl.isOwn ? " (общий, автор: " + tpl.ownerName + ")" : "" }}
            </option>
          </select>
          <v-btn
            small
            color="pink"
            :disabled="!selectedTemplateId || applyingTemplate"
            @click="confirmApplyTemplate"
          >
            {{ applyingTemplate ? "Применение..." : "Применить" }}
          </v-btn>
        </div>

        <transition name="fade">
          <section style="position: absolute; width: 100%;">
            <v-container v-if="updateLoad">
              <div class="text-center">
                <v-progress-circular indeterminate></v-progress-circular>
              </div>
            </v-container>
          </section>
        </transition>

        <div v-if="!updateLoad" style="margin-top: 20px;" class="custom-accordion">
          <div class="container-color" style="position:relative; padding: 16px 30px 30px;">

            <div class="rights-tree-head">
              <div class="rights-tree-head__top">
                <span class="rights-tree-head__title">{{ titleSkill }}</span>
              </div>
              <div class="rights-tree-head__cols">
                <span
                  v-for="btn in rightsButtons"
                  :key="'headcol_' + btn.id"
                  class="rights-tree-head__col"
                  :title="btn.description"
                >
                  {{ btn.description }}
                </span>
              </div>
            </div>

            <RightsTreeNode
              v-for="itemArea in visibleAreas"
              :key="itemArea.id"
              :node="itemArea"
              :level="1"
              :chain="[]"
              :open-ids="arrayOpen"
              :rights-buttons="rightsButtons"
              :get-right="getRight"
              @toggle-open="openBlock"
              @toggle-open-deep="openBlockDeep"
              @toggle-right="toggleRight"
              @go-to="goTo"
            />

          </div>
        </div>

      </div>
    </div>

    <ConfirmDialog
      v-if="showApplyTemplateConfirm"
      :visible="true"
      title="Применить шаблон?"
      text="Все текущие права сотрудника на дерево компетенций будут удалены и заменены содержимым шаблона. Это действие нельзя отменить."
      confirm-label="Применить"
      @confirm="applyTemplate"
      @cancel="showApplyTemplateConfirm = false"
    />
  </section>
</template>

<script>
import GlobalRequest from "@/plugins/globalRequest"
import EditedUser from "@/components/Cards/EditedUser.vue";
import NotificationTemplate from "@/pages/Notifications/NotificationTemplate";
import RightsTreeNode from "@/components/RightsTreeNode.vue";
import ConfirmDialog from "@/components/ConfirmDialog.vue";

export default {
  name: "AppointmentCompetention",
  components: {
    EditedUser,
    RightsTreeNode,
    ConfirmDialog,
  },

  inject: ["usersStore", "openInterview"],

  data() {
    return {
      data: null, // hardSkills/softSkills объект
      titleSkill: "",
      userData: {},

      preloader: true,
      updateLoad: false,
      preloaderBtn: false,

      userID: 0,
      typeSkill: "", // hs / ss

      errorText: "",
      infoText: "",
      arrayOpen: [],

      templates: [],
      selectedTemplateId: null,
      applyingTemplate: false,
      showApplyTemplateConfirm: false,

      rightsButtons: [
        { id: 1, title: "canView",       right: 'VIEW',           color: "#5d30b2", description: "просмотр компетенции", },
        { id: 2, title: "canViewScore",  right: 'VIEW_SCORE',     color: "#3091B2",   description: "просмотр оценки", },
        { id: 3, title: "canPostScore",  right: 'POST_SCORE',     color: "#229863",  description: "оценка компетенции", },
        { id: 4, title: "canPostAnswer", right: 'POST_ANSWER',    color: "#BB992F", description: "ответ на задание", },
        { id: 6, title: "canViewReferenceAnswer", right: 'VIEW_REFERENCE_ANSWER', color: "#a85c00", description: "просмотр эталонного ответа", },
        { id: 5, title: "assigned",      right: 'ASSIGN_ELEMENT', color: "#B33C12",    description: "назначить компетенцию" },
      ],

      ignoreInitialSkillEmit: true,
    };
  },

  computed: {
    users() {
      const list = this.usersStore.users || [];
      return list.filter((u) => u && u.active !== false);
    },
    showContent() {
      return this.preloader ? "hidden-block" : "show-block";
    },
    visibleAreas() {
      const list = (this.data && this.data.areas) ? this.data.areas : [];
      return list.filter((item) => item.type !== "task" && item.type !== "question");
    },
  },

  watch: {
    users: {
      immediate: true,
      handler: function (val) {
        if (!val || !val.length) return;

        if (!this.userID || this.userID === 0) {
          const persisted = this.readPersistedSelection();
          if (persisted && persisted.userID) {
            this.userID = persisted.userID;
          }
        }

        if (!this.userID || this.userID === 0) {
          this.trySetFirstUserFromList();
        }

        if (!this.typeSkill) {
          const persisted = this.readPersistedSelection();
          if (persisted && persisted.typeSkill) this.typeSkill = persisted.typeSkill;
        }
        if (!this.typeSkill) this.typeSkill = "hs";

        this.persistSelection();
        this.getCompetentions(this.userID, this.typeSkill);
      }
    }
  },

  mounted() {

    if (this.$route.query.userID) this.userID = Number(this.$route.query.userID);
    if (this.$route.query.typeSkill) this.typeSkill = String(this.$route.query.typeSkill);

    if (!this.userID || this.userID === 0 || !this.typeSkill) {
      var persisted = this.readPersistedSelection();

      if ((!this.userID || this.userID === 0) && persisted.userID) {
        this.userID = persisted.userID;
      }

      if (!this.typeSkill && persisted.typeSkill) {
        this.typeSkill = persisted.typeSkill;
      }
    }

    if (!this.typeSkill) this.typeSkill = "hs";

    this.ignoreInitialSkillEmit = true;
    this.$nextTick(() => {
      this.ignoreInitialSkillEmit = false;
    });

    if (!this.userID || this.userID === 0) {
      this.trySetFirstUserFromList();
    }

    this.persistSelection();

    this.loadTemplates();

    // await this.getCompetentions(this.userID, this.typeSkill);
  },

  methods: {

    async loadTemplates() {
      const res = await GlobalRequest.request("/competency-templates", "GET");
      this.templates = res && res.success && Array.isArray(res.data) ? res.data : [];
    },

    confirmApplyTemplate() {
      if (!this.selectedTemplateId || !this.userID) return;
      this.showApplyTemplateConfirm = true;
    },

    async applyTemplate() {
      this.showApplyTemplateConfirm = false;
      this.applyingTemplate = true;
      this.errorText = "";
      this.infoText = "";

      const res = await GlobalRequest.request(
        "/competency-templates/" + this.selectedTemplateId + "/apply/" + this.userID,
        "POST"
      );

      this.applyingTemplate = false;

      if (!res || !res.success) {
        this.errorText = (res && res.error) || "Не удалось применить шаблон";
        return;
      }

      this.infoText = "Шаблон применён";
      this.selectedTemplateId = null;
      this.updateLoad = true;
      await this.getCompetentions(this.userID, this.typeSkill);
    },

    openBlock(id) {
      var idx = this.arrayOpen.indexOf(id);
      if (idx !== -1) this.arrayOpen.splice(idx, 1);
      else this.arrayOpen.push(id);
    },

    // раскрыть/свернуть всю ветку целиком (Shift+клик по +/-)
    openBlockDeep(ids, shouldOpen) {
      if (!ids || !ids.length) return;

      if (shouldOpen) {
        ids.forEach((id) => {
          if (!this.arrayOpen.includes(id)) this.arrayOpen.push(id);
        });
      } else {
        this.arrayOpen = this.arrayOpen.filter((id) => !ids.includes(id));
      }
    },

    getEmpty() {
      return !(this.userID && this.userID !== 0);
    },

    // targetRights
    getRight(node, key) {
      if (!node || !node.targetRights) return false;
      return !!node.targetRights[key];
    },

    // targetRights есть у всех элементов
    normalizeRightsTree(node) {
      if (!node) return;

      if (!node.targetRights) {
        this.$set(node, "targetRights", {
          canView: false,
          canViewScore: false,
          canPostAnswer: false,
          canPostScore: false,
          assigned: false,
          canViewReferenceAnswer: false,
        });
      }

      if (node.children && node.children.length) {
        for (var i = 0; i < node.children.length; i++) {
          this.normalizeRightsTree(node.children[i]);
        }
      }
    },

    // применить право рекурсивно вниз
    // applyRightDown(children, key, value) {
    //   if (!children || !children.length) return;

    //   for (var i = 0; i < children.length; i++) {
    //     var child = children[i];

    //     if (!child.targetRights) {
    //       this.$set(child, "targetRights", {
    //         canView: false,
    //         canViewScore: false,
    //         canPostAnswer: false,
    //         canPostScore: false,
    //         assigned: false,
    //       });
    //     }

    //     // ключ
    //     this.$set(child.targetRights, key, value);

    //     // рекурсия
    //     if (child.children && child.children.length) {
    //       this.applyRightDown(child.children, key, value);
    //     }
    //   }
    // },

    // клик по чекбоксу права
    async toggleRight(node, btn, descendants) {
      if (!node || !btn) return;

      const hasRight = node.targetRights && node.targetRights[btn.title] === true;
      const action = hasRight ? "revoke" : "assign";

      // если есть потомки — каскадируем состояние вниз одним bulk-запросом
      if (descendants && descendants.length) {
        const body = {
          rootElementId: node.id,
          elementIds: [node.id, ...descendants.map((d) => d.id)],
          subordinateId: this.userID,
          right: btn.right,
          action: action,
        };

        const res = await GlobalRequest.request(`/assigment/manage-right-bulk`, "POST", body);
        if (!res || res && res.error) {
          await this.notifyVue("bottom", "right", "Не удалось изменить назначение права");
          return;
        }

        const skillKey = this.typeSkill === "hs" ? "hardSkills" : "softSkills";
        const branch = res && res[skillKey] && res[skillKey].areas ? res[skillKey].areas[0] : null;

        if (branch) this.applyBranchRights(branch);
        return;
      }

      const body = {
        elementId: node.id,
        subordinateId: this.userID,
        right: btn.right,
        action: action,
        returnType: "branch"
      };

      const res = await GlobalRequest.request(`/assigment/manage-right`, "POST", body);
      if (!res || res && res.error) {
        await this.notifyVue("bottom", "right", "Не удалось изменить назначение права");
        return;
      }

      const skillKey = this.typeSkill === "hs" ? "hardSkills" : "softSkills";
      const branch = res && res[skillKey] && res[skillKey].areas ? res[skillKey].areas[0] : null;

      if (branch) this.applyBranchRights(branch);
    },

    async notifyVue(verticalAlign, horizontalAlign, text) {
      this.$notify({
        component: NotificationTemplate,
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: "danger",
        message: text,
      });
    },

    getSkillTypeCurrent(type) {
      if (this.ignoreInitialSkillEmit && this.typeSkill) return;
      
      if (String(type) === String(this.typeSkill)) return;

      this.updateLoad = true;
      this.typeSkill = type;
      this.persistSelection();
      this.getCompetentions(this.userID, type);
    },

    getCurrentUserData(id) {
      var nextId = Number(id || 0);
      if (!nextId || nextId === Number(this.userID)) return;

      this.updateLoad = true;
      this.userID = id; 
      this.persistSelection();
      this.getCompetentions(id, this.typeSkill);
    },

    async getCompetentions(idCurrentUser, currentTypeSkill) {
      if (idCurrentUser) this.userID = idCurrentUser;
      if (currentTypeSkill) this.typeSkill = currentTypeSkill;
      if (!this.typeSkill) this.typeSkill = "hs";

      if (!this.userID) {
        this.preloader = false;
        this.updateLoad = false;
        return;
      }

      var resp = await GlobalRequest.request("/competencies/" + this.userID, "GET");

      var hs = resp  ? resp.hardSkills : null;
      var ss = resp  ? resp.softSkills : null;

      if (this.typeSkill === "hs") {
        this.data = hs;
        this.titleSkill = hs && hs.title ? hs.title : "Hard Skills";
      } else {
        this.data = ss;
        this.titleSkill = ss && ss.title ? ss.title : "Soft Skills";
      }

      if (this.data && this.data.areas && this.data.areas.length) {
        for (var i = 0; i < this.data.areas.length; i++) {
          this.normalizeRightsTree(this.data.areas[i]);
        }
      }

      this.persistSelection();

      this.preloader = false;
      this.updateLoad = false;
    },

    buildPayloadNode(node) {
      if (!node) return null;

      var out = {
        elementId: node.id,
        type: node.type,
        targetRights: node.targetRights ? {
          canView: !!node.targetRights.canView,
          canViewScore: !!node.targetRights.canViewScore,
          canPostAnswer: !!node.targetRights.canPostAnswer,
          canPostScore: !!node.targetRights.canPostScore,
          assigned: !!node.targetRights.assigned,
          canViewReferenceAnswer: !!node.targetRights.canViewReferenceAnswer,
        } : {
          canView: false, canViewScore: false, canPostAnswer: false, canPostScore: false, assigned: false, canViewReferenceAnswer: false,
        },
        children: [],
      };

      if (node.children && node.children.length) {
        for (var i = 0; i < node.children.length; i++) {
          var child = this.buildPayloadNode(node.children[i]);
          if (child) out.children.push(child);
        }
      }

      return out;
    },

    async saveApplication() {
      this.errorText = "";
      this.infoText = "";
      this.preloaderBtn = true;

      try {
        var areas = [];
        var list = this.data && this.data.areas ? this.data.areas : [];

        for (var i = 0; i < list.length; i++) {
          areas.push(this.buildPayloadNode(list[i]));
        }

        var body = {
          tag: this.typeSkill,  // hs/ss
          areas: areas,
        };

        var res = await GlobalRequest.request("/user/" + this.userID + "/competencies/manage", "POST", body);

        if (res && res.success) this.infoText = "Компетенции успешно назначены";
        else {
          this.errorText = "При назначении произошла ошибка";
          alert(this.errorText);
        }
      } catch (e) {
        this.errorText = "Ошибка запроса";
        alert(this.errorText);
      } finally {
        this.preloaderBtn = false;
      }
    },

    persistSelection() {
      if (this.userID) localStorage.setItem("appointment_user", String(this.userID));
      if (this.typeSkill) localStorage.setItem("appointment_skill", String(this.typeSkill));
    },

    readPersistedSelection() {
      var storedUser = localStorage.getItem("appointment_user");
      var storedSkill = localStorage.getItem("appointment_skill");

      return {
        userID: storedUser ? Number(storedUser) : 0,
        typeSkill: storedSkill ? storedSkill : "",
      };
    },

    trySetFirstUserFromList() {
      var list = this.users || [];
      if (!list.length) return;

      var first = list[0];

      var firstId = 0;
      if (first && typeof first.id !== "undefined") firstId = Number(first.id);
      else if (first && typeof first.value !== "undefined") firstId = Number(first.value);

      if (firstId) this.userID = firstId;
    },
    
    rightsToTarget(sub) {
      sub = sub || {};
      return {
        canView: !!sub.canView,
        canViewScore: !!sub.canViewScore,
        canPostAnswer: !!sub.canPostAnswer,
        canPostScore: !!sub.canPostScore,
        assigned: !!sub.assigned,
        canViewReferenceAnswer: !!sub.canViewReferenceAnswer,
      };
    },

    applyBranchRights(branchNode) {
      const rootList = (this.data && this.data.areas) ? this.data.areas : [];
      if (!branchNode || !rootList.length) return;

      const updateLocalById = (localNode, incoming) => {
        if (!localNode.targetRights) {
          this.$set(localNode, "targetRights", {
            canView: false,
            canViewScore: false,
            canPostAnswer: false,
            canPostScore: false,
            assigned: false,
            canViewReferenceAnswer: false,
          });
        }

        const next = this.rightsToTarget(incoming.subordinateRights);

        this.$set(localNode.targetRights, "canView", next.canView);
        this.$set(localNode.targetRights, "canViewScore", next.canViewScore);
        this.$set(localNode.targetRights, "canPostAnswer", next.canPostAnswer);
        this.$set(localNode.targetRights, "canPostScore", next.canPostScore);
        this.$set(localNode.targetRights, "assigned", next.assigned);
        this.$set(localNode.targetRights, "canViewReferenceAnswer", next.canViewReferenceAnswer);
      };

      const findLocal = (list, id) => {
        for (let i = 0; i < list.length; i++) {
          const n = list[i];
          if (String(n.id) === String(id)) return n;
          if (n.children && n.children.length) {
            const f = findLocal(n.children, id);
            if (f) return f;
          }
        }
        return null;
      };

      const walkIncoming = (incoming) => {
        if (!incoming || !incoming.id) return;

        const local = findLocal(rootList, incoming.id);
        if (local) updateLocalById(local, incoming);

        if (incoming.children && incoming.children.length) {
          for (let i = 0; i < incoming.children.length; i++) {
            walkIncoming(incoming.children[i]);
          }
        }
      };

      walkIncoming(branchNode);
    },

    goTo(item, chain) {
      if (!item || !item.id || !item.type) return;

      // массив родителей
      var parentsChain = Array.isArray(chain) ? chain : [];

      var newParents = parentsChain.map(function(n) {
        return { id: n.id, type: n.type };
      });

      // breadcrumbs в localStorage
      var crumbs = [
        { text: "Области знаний", type: "areasLayout", id: null }
      ];

      for (var i = 0; i < parentsChain.length; i++) {
        var p = parentsChain[i];
        crumbs.push({
          text: p.title || this.getTitleByType(p.type) || p.type,
          type: p.type,
          id: p.id
        });
      }

      // текущий элемент
      crumbs.push({
        text: item.title || this.getTitleByType(item.type) || item.type,
        type: item.type,
        id: item.id
      });

      localStorage.setItem("category_breadcrumbs", JSON.stringify(crumbs));

      const query = {
        ...this.$route.query,
        userID: this.userID
      };

      this.$router.push({
        name: item.type, // area/competency/theme/subtopic
        params: {
          id: item.id,
          parents: newParents
        },
        query
      });
    },

    getTitleByType(type) {
      const map = {
        area: "Компетенции",
        competency: "Темы",
        theme: "Подтемы",
        subtopic: "Вопросы и задания"
      };
      return map[type] || "";
    },

    // Назначение интервью
    addInterview(id) {
      this.openInterview(id);
    },

  },
};
</script>

<style scoped>

.rights {
  display: flex;
  align-items: center;
  margin-right: 10px;
}
.rights--indent { margin-left: 20px; }

.rights__cb {
  margin: 0 4px 0 0 !important;
  padding: 0 !important;
  max-width: 56px;
}

.custom-check { 
  height: 35px; 
}
.container-title { 
  padding: 0; 
}
.container-content { 
  padding: 0 0 0 26px; 
}
.container-title input { 
  cursor: pointer; 
}
.container-title h5 { 
  margin: 0; 
}
.container-title h5 b { 
  transition: 0.3s;
  cursor: pointer;
}
.container-title h5 b:hover { 
  text-decoration: underline;
}
.flex { 
  display: flex; 
  align-items: center; 
  padding-bottom: 5px;
}
.pd-flex { 
  padding: 5px 31px; 
}
.custom-accordion .v-expansion-panel-header { 
  min-height: 0 !important; 
  height: 50px !important; 
}
.res-text { 
  text-align: center; 
  max-width: 300px; 
  margin: 0 auto; 
}
.res-text p { 
  font-size: 14px !important; 
}

.btn-open-block{
  padding: 0 !important;
  width: 16px;
  height: 16px !important;
  min-width: 10px !important;
  font-size: 10px;
  border: 1px solid #737373;
  top: -1px;
  border-radius: 3px;
}
.horizontal-line {
/* .btn-open-block::after{ */
  content: " ";
  position: absolute;
  width: 20px;
  height: 1px;
  border-top: 1px dashed #888888;
  left: -20px;
  top: 11px;
}
.btn-open-block1::after{
  content: " ";
  position: absolute;
  width: 40px;
  height: 1px;
  border-top: 1px dashed #888888;
  left: -20px;
  top: 16px;
}
.container-area { 
  /* position: relative; */
  /* padding: 10px 0;  */
}
/* .container-area::after{ */
.vertical-line {
  content: " ";
  position: absolute;
  width: 10px;
  height: 100%;
  border-left: 1px dashed #888888;
  left: -20px;
  top: 0;
}
.btn-open-block span{
  padding: 0;
  width: 20px;
  height: 20px;
  min-width: 10px;
  font-size: 10px;
  border: 1px solid #c3c3c3;
}
.btn-open-block i { 
  font-size: 14px; 
  color: #c3c3c3; 
}

.marl-20 { margin-left: 29px; }
.marl-20::after{
  content: " ";
  position: absolute;
  width: 50px;
  height: 1px;
  border-top: 1px dashed #888888;
  left: -20px;
  top: 16px;
}

.rights {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-right: 10px;
}

.rights-btn {
  height: 20px;
  width: 20px;
  outline: 0;
  border: 0;
  border-radius: 4px;
  cursor: pointer;
  overflow: hidden;
  white-space: nowrap;
  transition: 0.3s ease;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0;
  position: relative;
}

.rights-btn.gray {
  filter: grayscale(1);
  opacity: 0.6;
}

.rights-btn i.v-icon {
  position: absolute;
  font-size: 18px;
  line-height: 1;
  left: 1px;
  top: 0;
}

button.blueBtn, button.blueBtn i.v-icon { background-color: #7CE4FE; color: #3091B2; }
button.greenBtn, button.greenBtn i.v-icon { background-color: #8EF3C5; color: #229863; }
button.yellowBtn, button.yellowBtn i.v-icon { background-color: #FFE28C; color: #BB992F; }
button.redBtn, button.redBtn i.v-icon { background-color: #FF8F5E; color: #B33C12; }
button.violetBtn, button.violetBtn i.v-icon { background-color: #be7cfe; color: #5d30b2; }

.uppercase {
  text-transform: uppercase;
}
.flex-block {
  display: flex;
  gap: 40px;
  align-items: flex-start;
}
.rights-absolute {
  position: absolute;
  left: 40px;
}
.custom-accordion_list {
  position: relative;
}
.hidden-block {
  opacity: 0;
}
.show-block {
  opacity: 1;
}
.mb-25 {
  margin-bottom: 25px !important;
}

/* Дерево назначения прав */
.rights-tree-head {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 8px 0 12px;
  border-bottom: 1px solid #e6e6e6;
  margin-bottom: 10px;
  position: sticky;
  top: 0;
  z-index: 2;
  background: #fff;
}
.rights-tree-head__top {
  display: flex;
  align-items: center;
}
.rights-tree-head__title {
  font-weight: 600;
  font-size: 16px;
}
.rights-tree-head__cols {
  display: flex;
  justify-content: flex-end;
  gap: 6px;
}
.rights-tree-head__col {
  width: 48px;
  flex: 0 0 auto;
  font-size: 10px;
  line-height: 1.15;
  color: #777;
  text-align: center;
  white-space: normal;
  word-break: break-word;
}
.rights-table__vcb .v-icon {
  font-size: 20px !important;
}
.apply-template-bar {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 12px;
}
.apply-template-select {
  padding: 6px 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 13px;
  min-width: 260px;
}
</style>
